module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > WLAN Disabled.13134649.jpg";